import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Colors, Title2, Icon } from 'advenio-components'

const Container = styled.div`
  margin-bottom: 16px;
  background-color: ${Colors.white500};
  text-align: left;
  border: 1px solid ${Colors.gray300};
  border-radius: 8px;
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${({ largePadding }) => largePadding ? '16px 24px' : '8px 16px'};
  color: ${Colors.white500};
  background-color: ${({ color }) => color || Colors.blue500};
  font-weight: bold;
  border-radius: 8px 8px 0 0;
`
const ContractDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`
const Heading = styled(Title2)`
  font-weight: bold;
  ${({ fontSize }) => fontSize ? `font-size: ${fontSize}px` : ''}
`
const MetaData = styled.p`
  margin-top: 0;
  margin-bottom: 4px;
  font-size: 13px;
  color: rgba(255,255,255, .5);
`
const Body = styled.div`
  ${({ paddedBody }) => paddedBody ? 'padding: 24px;' : ''}
`
const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`
const Button = styled(Icon)`
  margin-left:20%;
  display:inline-block;
`

class Island extends Component {
  state = {
    isHovered: false,
  }

  showActionButtons = () => {
    if (this.props.actionButtons && !this.state.isHovered) {
      this.setState({ isHovered: true })
    }
  }

  hideActionButtons = () => this.props.actionButtons && this.setState({ isHovered: false })

  render() {
    const { actionButtons, children, className, color, heading, button,
      headingFontSize, paddedBody, subHeading } = this.props
    const { isHovered } = this.state

    // We use onMouseOver instead of onMouseEnter due to a bug when opening a modal over the top.
    // When closing the modal, onMouseEnter would not trigger again if the cursor was still over
    // the Island.
    return (
      <Container
        className={className}
        onMouseOver={this.showActionButtons}
        onMouseLeave={this.hideActionButtons}
      >
        <Header color={color} largePadding={headingFontSize <= 18}>
          <ContractDetails>
            <Heading fontSize={headingFontSize}>{heading}</Heading>
            {subHeading && <MetaData>{subHeading}</MetaData>}
          </ContractDetails>
          {button && (<Button type="close" onClick={button} color="white" />)}
          {actionButtons && isHovered && <ActionButtons>{actionButtons}</ActionButtons>}
        </Header>
        <Body paddedBody={paddedBody}>
          {children}
        </Body>
      </Container>
    )
  }
}

Island.propTypes = {
  /** Optional action buttons to be injected into the Island header */
  actionButtons: PropTypes.node,
  /** Content to be injected into the Island body */
  children: PropTypes.node.isRequired,
  /** Custom CSS classes to be applied */
  className: PropTypes.string,
  /** Optional custom background-color to be applied to the Island header */
  color: PropTypes.string,
  /** Main title to be displayed in the header */
  heading: PropTypes.string.isRequired,
  /** Customize the font size of the Heading text */
  headingFontSize: PropTypes.number,
  /** Flag indicating if the body area should include padding */
  paddedBody: PropTypes.bool,
  /** Optional sub-heading to be displayed in the header */
  subHeading: PropTypes.string,
}

Island.defaultProps = {
  actionButtons: null,
  className: '',
  color: '',
  headingFontSize: null,
  onDelete: () => {},
  paddedBody: false,
  subHeading: '',
  button: null,
}

export default Island



// WEBPACK FOOTER //
// ./src/Components/Island/Island.jsx